import React, { useEffect, useRef } from "react";

export const ImageDataViewer: React.FC<{
    imageData: ImageData;
    width: number;
    height: number;
}> = (props) => {
    const { imageData, width, height } = props;

    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (!canvasRef.current) {
            return;
        }

        const context = canvasRef.current.getContext("2d");

        if (!context) {
            return;
        }

        context.putImageData(imageData, 0, 0);
    }, [imageData]);

    return <canvas ref={canvasRef} width={width} height={height} id="canvas" />;
};
